import React from 'react';
import { map, isEqual, find, head, isUndefined } from 'lodash';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { AddEditAllergies } from 'ui/containers/AddEditAllergies';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { editHealthInfoAllergies as EditHealthInfoAllergies } from 'ui/views/widgets/editHealthInfoAllergies';
 *
 * // render
 * <EditHealthInfoAllergies propName='propValue'/>
 */
export const editHealthInfoAllergies = ( props ) => {
    
    const others = find( props.sections, { name: 'others' }, {} );
    const othersFieldPlaceHolder = !isUndefined(others) && head( others.fields ).placeholder;
    const searchAndAddAllergies = find( props.sections, { name: 'searchAndAddAllergies' }, {} );
    const noDataConfig = find( props.sections, { name: 'noData' }, {} );
    

    return (
        <div className='ui-edit-health-info-allergies'>
            <div className='ui-edit-health-info-allergies__header'>

                {/* title for the modal */}
                <div className='ui-edit-health-info-allergies__header__title'>
                    { getLabel( props.widgetConfig.title ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>
            <div className='ui-edit-health-info-allergies__body'>

                <AddEditAllergies
                    notePlaceHolder = { othersFieldPlaceHolder }
                    items = { props.allergies }
                    addEditMemberHealthConfig = { searchAndAddAllergies }
                    onUpdate = { props.onUpdate }
                    selectionCriteria= { 'name' }
                    noDataConfig={ noDataConfig }
                    finalProp= {  props.finalprop }
                    allergiesVisibility = {props.visibility}
                    titlehealth={ 'AllergiesCondition' }
                />

                {/* actions : Cancel and Save */}
                <div className='ui-edit-health-info-allergies__body__actions'>
                    {
                        map( props.action, ( action ) => {
                            return (
                                <Button
                                    key={ action.name }
                                    id= { action.name }
                                    { ...action }
                                    outline={ 'cancel' === action.name ? true: false }
                                    size='large'
                                    className='ui-edit-health-info-allergies__body__actions__action'
                                    onClick = { isEqual( 'cancel', action.name ) ?  () => props.onCancelClick() : () => props.onSumbitClick() }
                                />
                            );
                        } )
                    }
                </div>
            </div>
        </div>
    );
};

// set display name
editHealthInfoAllergies.displayName = 'editHealthInfoAllergies';

// set default props
editHealthInfoAllergies.defaultProps = {};

// prop types
editHealthInfoAllergies.propTypes = {};
